export default "__VITE_ASSET__BglocF0W__"